<template>
  <div class="dw-footer-main" >
    <div>
      <span><a :href="footerInfo.siteUrl" style="color: #333;"><strong>{{ footerInfo.siteName }}</strong></a>&nbsp;</span>
      <span><a href="/" style="text-decoration: none;color: #333;">{{ footerInfo.siteIcp }}</a>&nbsp;{{ footerInfo.siteMail }}&nbsp;{{ footerInfo.sitePhone }}</span>
    </div>
    <div>
      <span>Powered by <a href="www.yungongzi.cn"><strong>青岛神州锐达信息技术有限公司</strong></a> {{ footerInfo.versionNumber }} Vue </span>
      <span> © {{ footerInfo.years }} <a href="www.yungongzi.cn"><strong>神州问调</strong></a></span>
    </div>
  </div>
</template>
<script>

import API from '@/api/index.js'

export default {
  name: 'DwFooter',
  data () {
    return {
      footerInfo: {
        siteName: '神州调问',
        siteUrl: 'http://www.yungongzi.cn',
        siteIcp: '鲁ICP备17050672号 ',
        siteMail: 'fht@yungongzi.cn',
        sitePhone: '18561562138',
        versionInfo: '神州问调 OSS V5.0 Vue',
        versionNumber: 'OSS V5.0',
        versionBuilt: '20211128',
        years: '2012-2021'
      }
    }
  },
  mounted () {
    this.queryDWSurveyFooter()
  },
  methods: {
    queryDWSurveyFooter () {
      this.axios.get(API.surveyFooterInfo, {}).then((response) => {
        const resultData = response.data.data
        console.debug(resultData)
        this.footerInfo = resultData
      })
    }
  }
}
</script>

<style scoped>
.dw-footer-main{
  text-align: center;
  font-size: 12px;
  color: grey;
  line-height: 30px;
  padding-top: 0px;
  padding-bottom: 20px;
}
.dw-footer-main a{
  text-decoration: none;
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DwFooter.vue